import { ListTerrotoriesSortOrder } from 'generated/graphql'
import type { ListTerrotoriesSortFields } from 'generated/graphql'
import type { INormalizedDataForTerritoriesTable } from 'utils/getNormalizedTerritoriesDataForTerritoriesTable'

import { GLOBAL_TAXONOMY_TERRITORY_TYPES, GLOBAL_TAXONOMY_TYPES_WITH_CHILDREN } from './global-topic.consts'
import type { IGlobalTaxonomyTerritoryGate, TTableOrder } from './global-topic.types'

export const handleSort = (data: INormalizedDataForTerritoriesTable[], order: TTableOrder) => {
  const sortField = order.field
  return data.sort((a, b) => {
    if (order.order === ListTerrotoriesSortOrder.Asc) {
      return a[sortField] - b[sortField]
    }
    return b[sortField] - a[sortField]
  })
}

export const getNextTableOrder = (previousOrder: TTableOrder, field: ListTerrotoriesSortFields): TTableOrder => {
  const toggledOrder =
    previousOrder.order === ListTerrotoriesSortOrder.Desc ? ListTerrotoriesSortOrder.Asc : ListTerrotoriesSortOrder.Desc
  return {
    field,
    order: previousOrder.field === field ? toggledOrder : ListTerrotoriesSortOrder.Desc,
  }
}

export const getIsGlobalTaxonomyTerritory = ({
  isGlobalTaxonomyEnabled,
  territoryType,
}: IGlobalTaxonomyTerritoryGate) => isGlobalTaxonomyEnabled && GLOBAL_TAXONOMY_TERRITORY_TYPES.includes(territoryType)

export const getHasGlobalTaxonomyChildren = ({
  isGlobalTaxonomyEnabled,
  territoryType,
}: IGlobalTaxonomyTerritoryGate) =>
  isGlobalTaxonomyEnabled && GLOBAL_TAXONOMY_TYPES_WITH_CHILDREN.includes(territoryType)
